import { productShareLinkStyles } from "@insite/content-library/Components/ProductShareLink";
import { mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

productShareLinkStyles.modal = {
    ...productShareLinkStyles.modal,

    cssOverrides: {
        ...productShareLinkStyles.modal?.cssOverrides,

        modalTitle: css`
            ${productShareLinkStyles.modal?.cssOverrides?.modalTitle}

            padding: 7px 10px;

            ${mediaQueriesBP.minMD} {
                padding: 7px 10px 7px 22px;
            }
        `,

        modalContent: css`
            ${productShareLinkStyles.modal?.cssOverrides?.modalContent}

            padding: 10px;

            ${mediaQueriesBP.minMD} {
                padding: 20px;
            }
        `,
    },
};
